var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQSameGray = function SvgQSameGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#EFF1F9",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80839E",
    d: "M7.058 9.342V7.829h5.885v1.513zm0 2.83v-1.514h5.885v1.513z"
  })));
};
export { SvgQSameGray as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNCIgZmlsbD0iI0VGRjFGOSIvPgo8cGF0aCBkPSJNNy4wNTc2MiA5LjM0MTY0VjcuODI4ODZIMTIuOTQyNlY5LjM0MTY0SDcuMDU3NjJaTTcuMDU3NjIgMTIuMTcxMlYxMC42NTg0SDEyLjk0MjZWMTIuMTcxMkg3LjA1NzYyWiIgZmlsbD0iIzgwODM5RSIvPgo8L3N2Zz4K";